import { storageService } from "../../services/StorageService.js";

export function STORE_USER_SETTING(state,payload){
      
    // payload={key,val}
    // other settings then schools
    state.user_stored[payload.key]=payload.val;
    var string=JSON.stringify(state.user_stored)
    storageService.setItem("user_stored", string );

  }